export const tableViews = state => state.tableViews.items
export const tableViewById = state => id => _.find(tableViews(state), {id: parseInt(id)})
export const currentTableView = state => tableViewById(state)(state.tableViews.currentId)

export const tableColumnNames = state => state.tableViews.tableColumnNames

export const tableViewsByType = state =>
    type => _.filter(tableViews(state), {type})

export const canEditView = (state, getters) => viewId => {
    let view = getters.tableViewById(viewId),
        user = getters.currentUser

    return user.role === 'admin' || view.is_public || getters.currentUserId === view.created_by
}

export const comparators = state => state.tableViews.comparators

export const filterMappings = state => state.tableViews.filterMappings
